module.exports = __webpack_public_path__ + "img/zk-icon-commodity-set.ae8d08dc.svg";